import template from './index.html'
import controller from './controller'

selectPartGrid.vsName = 'selectPartGrid'
selectPartGrid.vsNgType = 'directive'

selectPartGrid.$inject = []
function selectPartGrid() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: template,
    scope: {
      options: '='
    }
  }
}

export default selectPartGrid